module.exports = __webpack_public_path__ + "static/quiz_thumbnail_10-0646343390ff918bb8e496578c3522dc.jpg";